export type DailyAllowanceField = 'withoutStay' | 'withStay' | 'foreignWithStay';

/**
 * 日当金額の入力値を保存用の数値へ変換する。
 * 空欄は null のままにし、デフォルトの 0 をキー削除した状態を維持する。
 */
export const toDailyAllowanceAmount = (sanitized: string | number | null): number | null => {
  if (sanitized == null || sanitized === '') return null;
  const parsed = typeof sanitized === 'number' ? sanitized : parseInt(sanitized, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const dailyAllowanceInputKey = (
  gradeId: number | null,
  weight: number,
  field: DailyAllowanceField
): string => `${gradeId ?? 'new'}-${weight}-${field}`;

/**
 * 未入力の null は従来どおり 0 と表示し、入力中に消した空欄だけ空文字にする。
 */
export const dailyAllowanceDisplayedValue = (
  overrides: Record<string, string>,
  key: string,
  amount: number | null
): string | number => {
  if (Object.prototype.hasOwnProperty.call(overrides, key)) {
    return overrides[key];
  }
  return amount ?? 0;
};
